module.exports = __webpack_public_path__ + "static/media/uploadCancelActive.9af53b6c.svg";